import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDDialogActions, FDDialogContent, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import fr from 'facet-rest';
import { startAuthentication } from '@simplewebauthn/browser';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';

export const Layout = () => {
  const { resource, saving } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { setChallengeFlowCollection } = useIdentityChallengeContext();

  const onSubmit = async () => {
    try {
    // Pass the challenge to the browser's authenticator which will prompt the user to choose a
    // passkey that will sign the challenge.
      const credential = await startAuthentication({ optionsJSON: resource.attr('options').publicKey });

      // Send the signed challenge to the server for verification.
      // This uses fetch because the webauthn library requires a full HTTP request to be passed in, so they
      // dictate everything about it.  Our normal FR stuff won't be recognized by the webauthn lib.
      const res = await fetch(resource.link('self').url(), {
        credentials: 'include',
        mode: 'cors',
        method: 'POST',
        body: JSON.stringify(credential),
      });

      if (!res.ok) {
        throw new Error('Unable to verify passkey');
      }

      const json = await res.json();

      // This must be a response (not a collection) because this json will have includedResources on it and if we use
      // fr.collection the included resources will be stripped out because a collection does not know about included
      // resources
      setChallengeFlowCollection(fr.response(json));
    } catch (err) {
      displayErrorMessage(err, 'Failed to get verification');
    }

    return null;
  };

  return (
    <>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'stretch'} spacing={2} {...dataAttrs('dicrs-challenge-sms-layout')}>
          <MetaControlField attr={'primaryText'} />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          {...dataAttrs('submit-btn')}
          label={'Continue'}
          onClick={onSubmit}
          loading={saving}
        />
      </FDDialogActions>
    </>
  );
};

Layout.propTypes = {
};

Layout.defaultProps = {
};
